import { DataModel, DataModelBuilder, SerializationContext, SerializedData } from '../../models/dto/dto.js';
import { MapUtils } from '../../utility/map-utils.js';

export class StaffPrivacySettings extends DataModel {
  static readonly TYPE_ID: string = '6f028118001b4df49d8b97bbe9b9fe26';

  constructor(
    public readonly allowCalendarSharing: boolean,
  ) {
    super();
  }

  get $typeId(): string {
    return StaffPrivacySettings.TYPE_ID;
  }

  static none(): StaffPrivacySettings {
    return new StaffPrivacySettings(
        false,
    );
  }

  static fromMap(context: SerializationContext, map: SerializedData): StaffPrivacySettings {
    return new StaffPrivacySettings(
        MapUtils.get<boolean>(map, 'allowCalendarSharing'),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'allowCalendarSharing': this.allowCalendarSharing,
    };
  }

  clone(): this {
    return new StaffPrivacySettings(
        this.allowCalendarSharing,
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return other.allowCalendarSharing === this.allowCalendarSharing;
  }
}

export class StaffPrivacySettingsBuilder extends DataModelBuilder<StaffPrivacySettings> {
  build(context: SerializationContext, map: SerializedData): StaffPrivacySettings {
    return StaffPrivacySettings.fromMap(context, map);
  }
}
